import React from 'react';
import PropTypes from 'prop-types';

import * as S from './styles';
import Label from '../Label';

const InputField = ({
  onBlur,
  handleChange,
  labelText,
  placeholderText,
  width,
  value,
  name,
  pattern,
  type,
  min,
  max,
  step,
  isDisabled,
  labelPadding,
  hasLabelMargin,
  percent,
}) => (
  <S.Container fieldWidth={width}>
    <Label
      text={labelText}
      hasMargin={hasLabelMargin}
      htmlFor={name}
      pd={labelPadding}
    />

    <S.Input
      id={name}
      name={name}
      value={value}
      onChange={handleChange}
      onBlur={onBlur}
      placeholder={placeholderText}
      pattern={pattern}
      type={type}
      min={min}
      max={max}
      step={step}
      autoComplete="off"
      autoCapitalize="off"
      disabled={isDisabled}
    />
    {!!percent && <S.PercentLabel htmlFor={name}>%</S.PercentLabel>}
  </S.Container>
);

export default InputField;

InputField.defaultProps = {
  onBlur: () => {},
  handleChange: () => {},
  width: 100,
  value: '',
  pattern: '^.*',
  type: 'text',
  min: '',
  max: '',
  step: '',
  isDisabled: false,
  labelPadding: 0,
  hasLabelMargin: true,
  percent: false,
};

InputField.propTypes = {
  pattern: PropTypes.string,
  onBlur: PropTypes.func,
  handleChange: PropTypes.func,
  labelText: PropTypes.string.isRequired,
  placeholderText: PropTypes.string.isRequired,
  width: PropTypes.number,
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  type: PropTypes.string,
  min: PropTypes.string,
  max: PropTypes.string,
  step: PropTypes.string,
  isDisabled: PropTypes.bool,
  labelPadding: PropTypes.number,
  hasLabelMargin: PropTypes.bool,
  percent: PropTypes.bool,
};
